
export interface IPriceRulePopulatedAmount {
    _id: string,
    name: string,
    regex: string,
    params: IPriceRuleParams,
    rule: PriceRulesTypes,
    createdAt: Date,
    updatedAt: Date,
    isActive: boolean,
    amountOfTags: number
    isDeleted: boolean
}

interface IPriceRuleParams{
    number: number,
    by: PriceRuleParamBy
}

interface IDiscountParams{
    number: number
}

export enum PriceRulesTypes{
    "Revenue Share" = "Revenue Share",
    "Buffer" = "Buffer",
    "Bridge" = "Bridge"
}

export enum PriceRuleParamBy{
    PERCENT = "Percent",
    FIXED = "Fixed"
}